import axios from 'axios';
import { getToken, createApiUrl } from '../../../../../../util';
import api from 'api/axiosInstance';
import { FacetEditShadingStatus } from 'api/editDsm';

/**
 * Resolves with a FacetEditShadingStatus only when the reset left the shaded flux
 * stale — an NSRDB (in-house-simulation) ground-mount/flat facet, whose rows are baked
 * into the DSM. Empty otherwise; feed it to useStartShadingRecalc either way.
 */
export async function recalculateFacetLayoutRequest(payload: {designUuid: string; segmentIds: string[]; panelKey:string}):
	Promise<FacetEditShadingStatus | undefined> {
	const token = getToken('Authorization');
	const config = {
		headers: {
			'Authorization': `Bearer ${token}`
		}
	};

	const apiUrl = '/designs/reset-layout';
	const { data } = await api.post(createApiUrl(apiUrl), payload, config);
	return data;
}
